import { render, staticRenderFns } from "./CsrStrip.vue?vue&type=template&id=7dc9b61f&scoped=true&"
import script from "./CsrStrip.vue?vue&type=script&lang=js&"
export * from "./CsrStrip.vue?vue&type=script&lang=js&"
import style0 from "./CsrStrip.vue?vue&type=style&index=0&id=7dc9b61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc9b61f",
  null
  
)

export default component.exports